function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Center, End, Left, Right, Start, Vertical } from './constants';
import { value } from '../../util';
import { isObject, stringValue } from 'vega-util';
export function lookup(spec, config) {
  var _ = function _(name, dflt) {
    return value(spec[name], value(config[name], dflt));
  };

  _.isVertical = function (s) {
    return Vertical === value(spec.direction, config.direction || (s ? config.symbolDirection : config.gradientDirection));
  };

  _.gradientLength = function () {
    return value(spec.gradientLength, config.gradientLength || config.gradientWidth);
  };

  _.gradientThickness = function () {
    return value(spec.gradientThickness, config.gradientThickness || config.gradientHeight);
  };

  _.entryColumns = function () {
    return value(spec.columns, value(config.columns, +_.isVertical(true)));
  };

  return _;
}
export function getEncoding(name, encode) {
  var v = encode && (encode.update && encode.update[name] || encode.enter && encode.enter[name]);
  return v && v.signal ? v : v ? v.value : null;
}
export function getStyle(name, scope, style) {
  var s = scope.config.style[style];
  return s && s[name];
}
export function anchorExpr(s, e, m) {
  return "item.anchor === \"".concat(Start, "\" ? ").concat(s, " : item.anchor === \"").concat(End, "\" ? ").concat(e, " : ").concat(m);
}
export var alignExpr = anchorExpr(stringValue(Left), stringValue(Right), stringValue(Center));
export function tickBand(_) {
  var v = _('tickBand'),
      offset = _('tickOffset'),
      band,
      extra;

  if (!v) {
    // if no tick band entry, fall back on other properties
    band = _('bandPosition');
    extra = _('tickExtra');
  } else if (v.signal) {
    // if signal, augment code to interpret values
    band = {
      signal: "(".concat(v.signal, ")==='extent'?1:0.5")
    };
    extra = {
      signal: "(".concat(v.signal, ")==='extent'?true:false")
    };

    if (!isObject(offset)) {
      offset = {
        signal: "(".concat(v.signal, ")==='extent'?0:").concat(offset)
      };
    }
  } else if (v === 'extent') {
    // if constant, simply set values
    band = 1;
    extra = true;
    offset = 0;
  } else {
    band = 0.5;
    extra = false;
  }

  return {
    extra: extra,
    band: band,
    offset: offset
  };
}
export function extendOffset(value, offset) {
  return !offset ? value : !value ? offset : !isObject(value) ? {
    value: value,
    offset: offset
  } : _objectSpread({}, value, {
    offset: extendOffset(value.offset, offset)
  });
}